import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";

/**
* This source code is quoted from rc-upload.
* homepage: https://github.com/react-component/upload
*/
export default function getFileItem(file, fileList) {
  var matchWay = !file.uid ? 'byName' : 'byUid';
  var target = fileList.filter(function (item) {
    if (matchWay === 'byName') {
      return item.name === file.name;
    }

    return item.uid === file.uid;
  })[0];
  return target;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-upload/src/getFileItem.js